<template>
  <v-container grid-list-xl>
    <v-row wrap>
      <v-col cols="12">
        <m-alert
          v-if="$vuetify.breakpoint.mdAndUp"
          type="info"
          show
          :info="'Anda berada pada program Guru Belajar & Berbagi Seri <strong>' + current_instansi.nama + '</strong>. '"
        >
          <template v-slot:default>
            <span class="black--text">Ingin Beralih</span>
            <m-button class="mt-n1 mx-0" text textButton="ke Seri Lain?" action="toDashboard" @toDashboard="toDashboard()"></m-button>
          </template>
        </m-alert>
        <grid-c
          :gridConfig="grid"
          title="Daftar Angkatan"
          add
          search
          id-key
          filter
          refresh
          addText="Angkatan"
          @refresh="load"
          @filter="filter"
          :items="items"
          footerLabel="Angkatan"
          :variablePencarian="[{ key: 'Nama', value: 'nama' }]"
          @search="
            search => {
              dataPencarian = search;
              load();
            }
          "
          :page="page"
          @change:page="
            pg => {
              cp = pg;
              load();
            }
          "
          @add="add"
          footer
        >
          <template v-slot:items="{ item }">
            <v-divider></v-divider>
          </template>
        </grid-c>
      </v-col>
      <ChangeDlg ref="dlg" />
    </v-row>
  </v-container>
</template>

<script>
import { ALERT_INFO } from "@/const";
import { isCan } from "@/tools";
import ChangeDlg from "../components/Form.vue";
import FilterKelas from "@/filter/FilterKelas.vue";

//@group Angkatan
export default {
  name: "angkatan-list",
  components: {
    ChangeDlg,
    FilterKelas
  },
  data() {
    return {
      alert: ALERT_INFO,
      items: [],
      peran: null,
      page: null,
      cp: 1,
      dataPencarian: null,
      more_menu: [
        // eslint-disable-next-line
        {
          title: "Ubah",
          icon: "mdi-pencil",
          color: "orange",
          click: (i, o) => this.edit(o)
        },
        {
          title: "Hapus",
          icon: "mdi-delete",
          color: "error",
          click: (i, o) => this.hapus(o)
        }
      ]
    };
  },
  computed: {
    grid() {
      const conf = [
        {
          header: "Nomor",
          name: "nomor",
          align: "left",
          class: "black--text",
          type: "string",
          cols: 12,
          sm: 2,
          md: 2,
          lg: 2
        },
        {
          header: "Nama",
          name: "nama",
          align: "left",
          class: "black--text",
          type: "string",
          cols: 12,
          sm: 4,
          md: 4,
          lg: 4
        },
        {
          header: "Kuota",
          name: "kuota",
          align: "left",
          class: "black--text",
          type: "string",
          cols: 12,
          sm: 4,
          md: 4,
          lg: 4
        },
        {
          header: "Aksi",
          type: "more",
          more: this.more_menu,
          cols: 1,
          sm: 1,
          md: 1,
          lg: 1
        }
      ];
      return conf;
    },
    headers() {
      const a = [
        { text: "", align: "left", value: "" },
        { text: "", align: "left", value: "" },
        { text: "", align: "left", value: "" },
        { text: "", align: "left", value: "" },
        { text: "", sortable: false }
      ];
      return a;
    },
    //@vuese
    //pengecekan apakah memiliki akses kelola kelas (CRUD kelas)
    addData() {
      return isCan("kelas");
    }
  },
  mounted() {
    this.load();
  },
  methods: {
    //@vuese
    //kembali ke halaman kelola seri
    toDashboard() {
      this.$router.push({ name: "instansi.pilih.admin" });
    },
    //@vuese
    //menampilkan daftar Angkatan sesuai instansi aktif dan parameter yang digunakan
    load() {
      var params = {
        page: this.cp,
        peran: this.peran
      };

      if (this.dataPencarian) {
        var param = this.dataPencarian.param.value;
        params[param] = this.dataPencarian.s;
      }

      return this.$store
        .dispatch("angkatan/get", {
          instansi_id: this.instansi_id,
          params: params
        })
        .then(res => {
          this.page = res;
          this.items = res.data;
        })
        .catch(e => e);
    },
    filter(data) {
      this.peran = data.peran;
      this.load();
    },
    //@vuese
    //tampilkan form input angkatan
    add() {
      this.$refs.dlg.open().then(() => {
        this.load();
      });
    },
    //@vuese
    //tampilkan form edit angkatan
    // @args objek angkatan
    edit(item) {
      this.$refs.dlg.open(item).then(() => {
        this.load();
      });
    },
    //@vuese
    //hapus angkatan
    // @args objek angkatan
    hapus(item) {
      this.$confirm(
        `Apakah Anda yakin akan menghapus angkatan ini ?<br>
        <div class="mt-2 title grow text-center">
          ${item.nama}<br>
        </div>`
      )
        .then(() => this.$store.dispatch("angkatan/drop", item))
        .then(() => {
          this.$info("Angkatan " + item.nama + " berhasil dihapus");
        })
        .then(() => this.load())
        .catch(e => e);
    }
  },
  watch: {
    instansi_id() {
      this.load();
      this;
    }
  }
};
</script>
